<label soho-label [attr.for]="id">{{fieldLabel}}</label>
<!-- showAlert is set for structures dialog if there is a reporting basis-->
<ng-template [ngIf]="showAlert" [ngIfElse]="regular">
  <input *ngIf="!immutable" type="text"
      [attr.id]="id"
      [(ngModel)]="lookupValue"
      (ngModelChange)="onNgModelChange($event)"
      soho-alert
      soho-lookup
      [click]="onLookupClick"
      [field]="onLookupField"
      soho-busyindicator
      blockUI="true"
      displayDelay="0"
      (change)="onValueChanged($event)"
  />
  <p *ngIf="immutable"
      [attr.id]="id"
      class="lm-text-data hide-white-space"
      [ngStyle]="{'display': 'inline-block'}"
      [class.data]="true"
  >{{lookupValue}}</p>
</ng-template>
<!-- All other cases -->
<ng-template #regular>
  <input *ngIf="!immutable" type="text"
      [attr.id]="id"
      [(ngModel)]="lookupValue"
      (ngModelChange)="onNgModelChange($event)"
      soho-trackdirty
      soho-lookup
      [click]="onLookupClick"
      [field]="onLookupField"
      soho-busyindicator
      blockUI="true"
      displayDelay="0"
      (change)="onValueChanged($event)"
  />
  <p *ngIf="immutable"
      [attr.id]="id"
      class="lm-text-data hide-white-space"
      [ngStyle]="{'display': 'inline-block'}"
      [class.data]="true"
  >{{lookupValue}}</p>
</ng-template>
<div #lookupBasicPlaceholder id="lookupBasicPlaceholder"></div>
